import { CardGrid } from './CardGrid/CardGrid';
import { Hero } from './Hero/Hero';
import { LogoFooter } from './LogoFooter/LogoFooter';
import { useAppCardProps } from './hooks/useAppCardProps';

export const Home = () => {
  const appCardProps = useAppCardProps();

  return (
    <>
      <Hero />
      <CardGrid cards={appCardProps} />
      <LogoFooter />
    </>
  );
};
